// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__E0YXB","bold":"Breadcrumbs_bold__ScBrX"};